import { useState, useMemo } from "react"
import { Table, Column, Data, FieldType, FieldValue, Section, O } from "../../../../../features/ui"
import { TableName } from "../../../../../tables"
import { define } from "../../../../../utils/typeUtils"
import { Product, ProductName } from "../../../../products"
import { useFind } from "../../../../../state/reducers/hooks"
import { INITIAL_SORT_STATE, SortState, nextSortState, sortRows, withSortHeaders } from "../../../../../features/data-types"

type Props = {
    rows: Data[]
    readOnly?: boolean
    onAdd?: () => void
    onRemoveRow?: (productId: string) => void
}

export const NonHoardableProductsTable = (props: Props) => {
    const { rows, readOnly, onAdd, onRemoveRow } = props

    const find = useFind()

    const [sortState, setSortState] = useState<SortState>(INITIAL_SORT_STATE)
    const onColumnSort = (name: string) => setSortState(prev => nextSortState(prev, name))

    const columns: Column[] = [
        {
            name: 'productId',
            type: FieldType.TABLE,
            table: TableName.PRODUCTS,
            label: 'Producto',
            sortValue: (value?: FieldValue) => (find(TableName.PRODUCTS, value as string) as { name?: string })?.name ?? '',
            render: (value?: FieldValue) => {
                const productId = value as O<string>
                const product = define(find(TableName.PRODUCTS, productId)) as Product
                return <ProductName product={product} />
            }
        }
    ]

    const sortedRows = useMemo(() => {
        if (!sortState.column || !sortState.direction) return rows
        const col = columns.find(c => c.name === sortState.column)
        if (!col) return rows
        return sortRows(rows, col, sortState.direction)
    }, [rows, sortState])

    const sortableColumns = withSortHeaders(columns, sortState, onColumnSort)

    return (
        <Section
            id='nonHoardableProducts'
            space={12}
        >
            <Table
                columns={sortableColumns}
                rows={sortedRows}
                rowId='productId'
                readOnly={readOnly}
                createIcon="plus"
                small
                onCreate={onAdd}
                onRemove={onRemoveRow}
            />
        </Section>
    )
}
